import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import React, { useEffect, useState } from 'react'
import { Container } from '../Container'
import macbookImage from '../../assets/15_Macbook_Pro.png'
import testing from '../../assets/testing.png'
import testBanner from '../../assets/TEST-BANNER.jpeg'
import { axiosInstance } from '../../helpers'
import { VendorAd } from '../../models'

interface Props {
    type: 'LOGO_AD' | 'BANNER_AD'
    style?: React.CSSProperties
    imgStyle?: React.CSSProperties
}

export const AdCarousel = (props: Props) => {
    const { type, style, imgStyle } = props

    const [images, setImages] = useState<string[]>([])

    useEffect(() => {
        axiosInstance
            .get('company/vendor_ad', {
                params: {
                    ad_type: type,
                },
            })
            .then((res) => {
                const data = res.data as VendorAd[]
                const newImages = data.reduce<string[]>((prev, ad) => {
                    return prev.concat(ad.ad)
                }, [])
                setImages(newImages)
            })
    }, [])

    interface ImageProps {
        image: string
    }

    const Image = (props: ImageProps) => {
        return (
            <img
                src={props.image}
                style={{ objectFit: 'contain', ...imgStyle }}
            />
        )
    }

    return (
        <Container style={style}>
            <Carousel
                selectedItem={images.length - 1} // will display last image to start, prevents a bug where auto-scroll does not happen
                autoPlay
                infiniteLoop
                swipeable={false}
                showThumbs={false}
                useKeyboardArrows={false}
                showArrows={false}
                showIndicators={false}
                showStatus={false}
            >
                {images.map((image, idx) => {
                    return <Image image={image} key={`${image}_${idx}`} />
                })}
            </Carousel>
        </Container>
    )
}
